import React, { Component } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import usuarios from "../../api/usuarios";

interface LoginPageProps {
  onTokenChanged: (token: string) => void;
}

interface LoginPageState {
  usuario: string;
  senha: string;
  error?: string;
  loading: boolean;
}

export class LoginPage extends Component<LoginPageProps, LoginPageState> {
  constructor(props: LoginPageProps) {
    super(props);
    this.state = {
      usuario: "",
      senha: "",
      loading: false,
    };
  }

  onUsuarioChanged(value: string) {
    this.setState({ usuario: value });
  }

  onSenhaChanged(value: string) {
    this.setState({ senha: value });
  }

  onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    this.setState({ loading: true, error: undefined });

    usuarios
      .login(this.state.usuario, this.state.senha)
      .then((res) => {
        this.props.onTokenChanged(res.token);
      })
      .catch((err) => {
        this.setState({ error: err.message ?? err.toString() });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render(): React.ReactNode {
    return (
      <div style={{ maxWidth: "600px", margin: "0 auto" }}>
        {this.state.error && (
          <Alert color="danger" data-cy="alert">
            {this.state.error}
          </Alert>
        )}
        <Card>
          <CardBody>
            <CardTitle tag="h5">Login</CardTitle>
            <Form onSubmit={(e) => this.onSubmit(e)}>
              <FormGroup row>
                <Label for="txtUsuario" sm={2}>
                  Usuário:
                </Label>
                <Col sm={10}>
                  <Input
                    id="txtUsuario"
                    data-cy="usuario"
                    value={this.state.usuario}
                    onChange={(e) => this.onUsuarioChanged(e.target.value)}
                    required
                    disabled={this.state.loading}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="txtSenha" sm={2}>
                  Senha:
                </Label>
                <Col sm={10}>
                  <Input
                    id="txtSenha"
                    data-cy="senha"
                    type="password"
                    value={this.state.senha}
                    onChange={(e) => this.onSenhaChanged(e.target.value)}
                    required
                    disabled={this.state.loading}
                  />
                </Col>
              </FormGroup>
              <Row>
                <Col sm={2} />
                <Col sm={8} className="text-center">
                  <Button
                    data-cy="submit"
                    type="submit"
                    disabled={this.state.loading}
                  >
                    Entrar
                  </Button>
                </Col>
                <Col sm={2} className="text-right">
                  {this.state.loading && <Spinner />}
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}
